import { GenIcon } from '../helpers/IconBase.es.js';

const MobileBankingColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M3.305 2.87C2.585 2.87 2 3.454 2 4.175V20.696C2 21.416 2.585 22 3.305 22H13.739C14.459 22 15.043 21.416 15.043 20.696V4.175C15.043 3.454 14.459 2.87 13.739 2.87H3.305Z",
          fill: "#747474"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.65186 19.8271C7.65186 20.3071 8.04086 20.6961 8.52286 20.6961C9.00186 20.6961 9.39086 20.3071 9.39086 19.8271C9.39086 19.3471 9.00186 18.9561 8.52286 18.9561C8.04086 18.9561 7.65186 19.3471 7.65186 19.8271Z",
          fill: "#A0A0A0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3.73918 5.04395C3.50018 5.04395 3.30518 5.23795 3.30518 5.47795V17.2179C3.30518 17.4569 3.50018 17.6539 3.73918 17.6539H13.3042C13.5462 17.6539 13.7392 17.4569 13.7392 17.2179V5.47795C13.7392 5.23795 13.5462 5.04395 13.3042 5.04395H3.73918Z",
          fill: "#A0A0A0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.6962 2C10.2172 2 9.82617 2.389 9.82617 2.87V9.827C9.82617 10.307 10.2172 10.697 10.6962 10.697H21.1322C21.6112 10.697 22.0002 10.307 22.0002 9.827V2.87C22.0002 2.389 21.6112 2 21.1322 2H10.6962Z",
          fill: "#42A5DC"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.82617 5.91301H22.0002V3.73901H9.82617V5.91301Z",
          fill: "#213E49"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1299 7.87049C11.1299 8.23031 11.4216 8.52199 11.7814 8.52199H15.2624C15.6222 8.52199 15.9139 8.23031 15.9139 7.87049C15.9139 7.51068 15.6222 7.21899 15.2624 7.21899H11.7814C11.4216 7.21899 11.1299 7.51068 11.1299 7.87049Z",
          fill: "#FEFEFE"
        }
      }
    ]
  })(props);
};

export { MobileBankingColored };
